module.exports = __webpack_public_path__ + "static/media/restaurant1.020981ce.jpg";